export const url = `https://api.e-justice-sud.uz/`